import { EligibilityInfo } from "../api/eligibilityApiModel";

export const verifyEligibility = (eligibilityData: EligibilityInfo) => {
  if (!eligibilityData.provider) {
    throw new Error("Eligibility provider is missing");
  }

  if (!eligibilityData.subscriber) {
    throw new Error("Eligibility subscriber is missing");
  }

  const { firstName, lastName, organizationName } = eligibilityData.provider;

  if (!firstName && !lastName && !organizationName) {
    throw new Error(
      "You must specify either both firstName and lastName, or organizationName in eligibility.provider"
    );
  }

  if (firstName && !lastName && !organizationName) {
    throw new Error(
      "lastName is required if firstName is provided in eligibility.provider"
    );
  }

  if (!firstName && lastName && !organizationName) {
    throw new Error(
      "firstName is required if lastName is provided in eligibility.provider"
    );
  }
};
